import { isOpen, isResolved } from '../../../netlify/functions/lib/bug-management/statuses'

/** Identity is scoped by the caller; a discovery wins over rediscoveries in that scope. */
export function uniqueBugs<T extends { id: string; is_duplicate?: boolean }>(bugs: readonly T[]): T[] {
  const byId = new Map<string, T>()
  for (const bug of bugs) {
    const previous = byId.get(bug.id)
    if (!previous || (previous.is_duplicate && !bug.is_duplicate)) byId.set(bug.id, bug)
  }
  return [...byId.values()]
}

/** Summarize the selected population, never association rows or a page's partial results. */
export function summarizeBugs<T extends { id: string; status?: string; severity?: string; is_duplicate?: boolean }>(rows: readonly T[]) {
  const bugs = uniqueBugs(rows)
  const bySeverity: Record<string, number> = {}
  let open = 0
  let resolved = 0
  for (const bug of bugs) {
    if (isOpen(bug.status)) open++
    if (isResolved(bug.status)) resolved++
    const severity = bug.severity?.toLowerCase() ?? 'unknown'
    bySeverity[severity] = (bySeverity[severity] ?? 0) + 1
  }
  return { total: bugs.length, open, resolved, bySeverity }
}
